import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { LucideDynamicIcon, LucidePanelLeftClose, LucidePanelLeftOpen } from "@lucide/angular";
import { SalaButtonDirective } from "@ui/directives/sala-button.directive";
import { TooltipDirective } from "@ui/directives/tooltip.directive";

@Component({
  selector: "layout-main-container-sidebar-opener",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SalaButtonDirective, LucideDynamicIcon, TooltipDirective],
  template: `
    <button [sala]="'ghost'" [tooltip]="tooltipText()" (click)="toggled.emit()">
      <svg [size]="20" [lucideIcon]="icon()"></svg>
    </button>
  `,
})
export class SidebarOpener {
  // Inputs
  readonly isOpen = input(false);

  // Outputs
  readonly toggled = output();

  // Computeds
  readonly icon = computed(() => (this.isOpen() ? LucidePanelLeftClose : LucidePanelLeftOpen));
  readonly tooltipText = computed(() =>
    this.isOpen() ? $localize`Close sidebar` : $localize`Open sidebar`,
  );
}
